export default __webpack_public_path__ + "static/media/Harry's Wand - Img - Wip 1_01.2a982591.jpg";